import { ErrorMessage, Field } from 'formik';
import useReportFieldError from '@/hooks/useReportFieldError';

const InputMobile = ({
  id,
  title,
  name,
  labelClassName = '',
  className = '',
  codeClassName = '',
  placeholder = '5XXXXXXXX',
  disabled = false,
}) => {
  useReportFieldError(name);
  return (
    <div className='flex flex-col gap-1'>
      <label
        className={`font-bold max-lg:text-sm ${labelClassName}`}
        htmlFor={id}
      >
        {title}
      </label>
      <div dir='ltr' className='flex items-center'>
        <span
          className={`mt-1 w-14 rounded-s-lg border border-[#E4E4F9] px-2 py-1.5 text-center max-lg:text-sm ${codeClassName}`}
        >
          +966
        </span>
        <Field
          name={name}
          id={id}
          inputMode='numeric'
          className={`mt-1 flex-1 rounded-e-lg border border-s-0 border-[#E4E4F9] px-2 py-1.5 outline-none max-lg:text-sm max-lg:placeholder:text-sm lg:px-4 ${className} disabled:cursor-not-allowed disabled:bg-gray-100`}
          placeholder={placeholder}
          maxLength={9}
          disabled={disabled}
        />
      </div>
      <ErrorMessage
        name={name}
        component='p'
        className='text-xs text-red-600 lg:text-sm'
      />
    </div>
  );
};

export default InputMobile;
